// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"

import $ from "jquery"

window.$ = window.jQuery = $

import "./controllers"
